import type { PlaceCardData } from './types';

/**
 * One place per card. Shows name + address/category + rating. The whole card
 * is clickable → onOpen() (focuses the places module on this object).
 * Mirrors EmailResultCard chrome (rc-card / rc-meta).
 */
export function PlaceResultCard({ data, onOpen }: { data: PlaceCardData; onOpen: () => void }) {
  const { name, address, category, rating } = data;

  return (
    <button type="button" className="rc-card rc-place" onClick={onOpen}>
      <div className="rc-meta">
        <span className="rc-meta-kind">📍 PLACE</span>
        {category && (
          <>
            <span className="rc-meta-sep">·</span>
            <span className="rc-meta-match">{category.toUpperCase()}</span>
          </>
        )}
      </div>

      <div className="rc-subject">{name || 'Unnamed place'}</div>
      <div className="rc-place-row">
        {address && <span className="rc-place-address">{address}</span>}
        {typeof rating === 'number' && (
          <span className="rc-place-rating">★ {rating.toFixed(1)}</span>
        )}
      </div>
    </button>
  );
}
